import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Clock } from 'lucide-react';

export default function BlogCard({ post }) {
  const date = post.publishedAt ? new Date(post.publishedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '';
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid="blog-card"
      className="group rounded-2xl bg-white border border-slate-900/10 p-6 shadow-[0_10px_30px_rgba(2,6,23,0.06)] transition-shadow hover:shadow-[0_20px_50px_rgba(2,6,23,0.10)] flex flex-col"
    >
      <span className="inline-flex w-fit items-center px-2.5 py-1 rounded-full bg-[#2563EB]/10 text-[#2563EB] text-[11px] font-semibold">
        {post.category}
      </span>
      <h3 className="font-display mt-3 text-lg font-bold text-slate-900 leading-snug group-hover:text-[#2563EB] transition-colors">
        {post.title}
      </h3>
      <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">{post.excerpt}</p>
      <div className="mt-5 pt-4 border-t border-slate-900/10 flex items-center justify-between text-xs text-slate-500">
        <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {post.readTime}</span>
        <span>{date}</span>
      </div>
      <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-[#2563EB]">
        Read more <ArrowUpRight className="h-3.5 w-3.5" />
      </span>
    </Link>
  );
}
